import type { ComputedRef } from 'vue'
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'

import { useListsStore } from '@shared/model'

export const SURVEY_EMPTY_CELL = '-'

interface SurveyOptionsReturn {
  typeOptions: ComputedRef<AppSelectOption[]>
  statusOptions: ComputedRef<AppSelectOption[]>
  sourceOptions: ComputedRef<AppSelectOption[]>
  getTypeLabel: (type: string) => string
  getSourceLabel: (source: string | null) => string
  getDisciplineLabel: (code: string) => string
}

const toOptions = (record: Record<string, string>): AppSelectOption[] =>
  Object.entries(record).map(([value, text]) => ({ value, text }))

export const useSurveyOptions = (): SurveyOptionsReturn => {
  const listsStore = useListsStore()

  const typeMap = computed<Record<string, string>>(() => listsStore.getLists?.surveys?.name ?? {})
  const statusMap = computed<Record<string, string>>(() => listsStore.getLists?.surveys?.status ?? {})
  const sourceMap = computed<Record<string, string>>(() => listsStore.getLists?.surveys?.source ?? {})
  const disciplineMap = computed<Record<string, string>>(() => listsStore.getLists?.discipline?.code ?? {})

  const typeOptions = computed<AppSelectOption[]>(() => toOptions(typeMap.value))
  const statusOptions = computed<AppSelectOption[]>(() => toOptions(statusMap.value))
  const sourceOptions = computed<AppSelectOption[]>(() => toOptions(sourceMap.value))

  const getTypeLabel = (type: string): string => typeMap.value[type] ?? type
  const getSourceLabel = (source: string | null): string => (source ? sourceMap.value[source] ?? source : SURVEY_EMPTY_CELL)
  const getDisciplineLabel = (code: string): string => disciplineMap.value[code] ?? code

  return {
    typeOptions,
    statusOptions,
    sourceOptions,
    getTypeLabel,
    getSourceLabel,
    getDisciplineLabel,
  }
}
